import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/store/auth-store';
import { OnboardingWizard } from '@/features/onboarding/components/OnboardingWizard';

/**
 * `/onboarding` lives at the top level (not under `_auth`) so the dashboard
 * auth guard can redirect *into* it without creating a redirect loop. We
 * still require a token here — if there isn't one, send the user to login.
 *
 * Non-admins shouldn't reach this page (only admins finish onboarding for
 * the tenant), and admins who already completed it shouldn't be stuck here
 * either, so we punt them to the inbox in those cases.
 */
export const Route = createFileRoute('/onboarding')({
  beforeLoad: () => {
    const { token, user } = useAuthStore.getState();
    if (!token) {
      throw redirect({ to: '/login' });
    }
    const role = user?.role ?? 'agent';
    const isAdmin = role === 'admin' || role === 'super_admin';
    if (!isAdmin) {
      throw redirect({ to: '/' });
    }
    if (user?.onboarding_completed === true) {
      throw redirect({ to: '/' });
    }
  },
  component: OnboardingWizard,
});
